import styled from 'styled-components/macro';
import ResponsiveContainer from '../../components/layout/ResponsiveContainer';
import mq from '../../utils/mediaQueriesBp';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
`;

const TabsHeading = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  justify-content: center;

  ${mq('desktop')} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Wrapper2 = styled(ResponsiveContainer)`
  flex-wrap: wrap;
  height: auto;
  overflow-y: auto;
`;

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;

  ${mq('desktop')} {
    margin-bottom: 0;
  }

  li {
    padding: 0;
    margin: -1px;

    @media (min-width: 480px) {
      bottom: 1px;
    }

    > div {
      border: 1px solid #6dc7dd;
    }

    &:not(:last-of-type) {
      > div {
        border-right: 0px;
      }
    }

    &:first-of-type > div {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &:last-of-type > div {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
`;

const TabButton = styled.div`
  display: flex;
  max-width: 400px;
  padding: 0 20px 0 20px;
  align-items: center;
  justify-content: center;
  height: 34px;
  color: #6dc7dd;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
  font-size: 14px;

  &:hover {
    background: #6dc7dd;
    color: #ffffff;
  }

  ${mq('laptop')} {
    padding: 0 70px 0 70px;
  }

  ${mq('desktop')} {
    padding: 0 30px 0 30px;
  }
`;
const TabButtonActive = styled.div`
  display: flex;
  max-width: 400px;
  padding: 0 10px 0 10px;
  align-items: center;
  justify-content: center;
  height: 34px;
  background: #0071ba;
  color: #ffffff;
  cursor: pointer;
  border-color: #0071ba !important;
  font-weight: 500;
  font-size: 14px;

  ${mq('laptop')} {
    padding: 0 70px 0 70px;
  }

  ${mq('desktop')} {
    padding: 0 30px 0 30px;
  }
`;

export {
  Wrapper,
  Inner,
  TabsHeading,
  Wrapper2,
  TabButton,
  TabButtonActive,
  TabContainer,
};
